import { render, staticRenderFns } from "./OverviewTwo.vue?vue&type=template&id=165ecc6d&"
import script from "./OverviewTwo.vue?vue&type=script&lang=js&"
export * from "./OverviewTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports